import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../CSS/Footer.css'

export default function Footer() {
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    return (
    <>
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 footer-contact" data-aos="fade-up" data-aos-delay="100">
                            <h3>Rayan Info Solutions<span></span></h3>
                            <p>501, Plot No 40 <br />Kailash Vihar,Jajmau<br />Kanpur <br /><br /><strong>Phone:</strong> +91 96707 96799<br />
                            <strong>Email:</strong> rayaninfosolutions@gmail.com<br />
                            </p>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links"  data-aos="fade-up" data-aos-delay="100">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i className="bi bi-chevron-right"></i> <Link className="nav-link" to="/" onClick={() => document.getElementById("carousel").scrollIntoView({ behavior: "smooth" })}>Home</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link to="#">Web Development</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link to="#">Software Development</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link to="#">Bulk SMS</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-6 footer-links"  data-aos="fade-up" data-aos-delay="100">
                            <h4>Company</h4>
                            <ul>
                                <li><i className="bi bi-chevron-right"></i> <Link className="nav-link" to="/" onClick={() => document.getElementById("AboutUs").scrollIntoView({ behavior: "smooth" })}>About Us</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link className="nav-link" to="/terms" onClick={() => document.getElementById("TermsAndConditions").scrollIntoView({ behavior: "smooth" })}>Terms and Conditions</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link className="nav-link" to="/PrivacyPolicy" onClick={() => document.getElementById("PrivacyPolicy").scrollIntoView({ behavior: "smooth" })}>Privacy Policy</Link></li>
                                <li><i className="bi bi-chevron-right"></i> <Link className="nav-link" to="/CancellationRefundPolicy" onClick={() => document.getElementById("CancellationRefundPolicy").scrollIntoView({ behavior: "smooth" })}>Cancellation & Refund Policy</Link></li> 
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-6 footer-links"  data-aos="fade-up" data-aos-delay="100">
                            <h4>Our Social Networks</h4>
                            <p></p>
                            <div className="social-links mt-3">
                                <Link to="https://www.facebook.com/share/1ExYswUqfz" className="facebook"><i className="bi bi-facebook"></i></Link>
                                <Link to="https://www.youtube.com/channel/UCchQWaHjSJYVnfrRzOMoX4Q" className="youtube"><i className="bi bi-youtube"></i></Link>
                                <Link to="https://wa.me/+919670796799" className="whatsapp"><i className="bi bi-whatsapp"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container py-4">
                <div className="copyright">
                    &copy; Copyright <strong><span>Rayan Info Solutions</span></strong>. All Rights Reserved
                </div>
                <div className="credits">Designed by Rayan Info Solutions</div>
            </div>
        </footer>
    </>
    )
}
